export const RESULT_PARENT = {
  selectors: [
    {
      title: 'Result type',
      options: ['Exam Result', 'Test Result', 'Assignment scores'],
    },
    {
      title: 'Sort by',
      options: ['First Term', 'Second Term', 'Third Term'],
    },
  ],

  result: [
    {
      subject: 'English Language',
      Remark: 'Good',
      score: 70,
    },
    {
      subject: 'Mathematics',
      Remark: 'Very Good',
      score: 81,
    },
    {
      subject: 'Social Studies',
      Remark: 'Excellent',
      score: 98,
    },
    {
      subject: 'Physics',
      Remark: 'Good',
      score: 65,
    },
    {
      subject: 'Chemistry',
      Remark: 'Good',
      score: 78,
    },
    {
      subject: 'Information Techology',
      Remark: 'Excellent',
      score: 99,
    },
    {
      subject: 'Biology',
      Remark: 'Pass',
      score: 45,
    },
  ],
}
